import React from 'react'

const ProductSupermarketCommentContainer = () => {
  return (
    <div>ProductSupermarketCommentContainer</div>
  )
}

export default ProductSupermarketCommentContainer